export default "__VITE_ASSET__CaJU8xoh__"